export const SOURCE_OPTIONS = [
  { value: "Abstrakt", label: "Abstrakt" },
  { value: "Allied Resources", label: "Allied Resources" },
  { value: "Broker Metrics", label: "Broker Metrics" },
  { value: "Career Builder", label: "Career Builder" },
  { value: "Career Hour", label: "Career Hour" },
  { value: "Career Workshop", label: "Career Workshop" },
  { value: "Co-op Agent", label: "Co-op Agent" },
  { value: "Cold Call", label: "Cold Call" },
  { value: "Courted", label: "Courted" },
  { value: "Direct Mail", label: "Direct Mail" },
  { value: "Educational Event", label: "Educational Event" },
  { value: "Email BCC'd", label: "Email BCC'd" },
  { value: "Email Campaign", label: "Email Campaign" },
  { value: "Email Forwarded", label: "Email Forwarded" },
  { value: "Facebook", label: "Facebook" },
  { value: "Friend of Referrer", label: "Friend of Referrer" },
  { value: "Indeed", label: "Indeed" },
  { value: "Instagram", label: "Instagram" },
  { value: "Job Posting", label: "Job Posting" },
  { value: "Landing Page", label: "Landing Page" },
  { value: "MLS", label: "MLS" },
  { value: "MarketView Broker", label: "MarketView Broker" },
  { value: "Networking", label: "Networking" },
  { value: "Open House Drop By", label: "Open House Drop By" },
  { value: "Other", label: "Other" },
  { value: "RB Agent Page", label: "RB Agent Page" },
  { value: "Real Estate Schools", label: "Real Estate Schools" },
  { value: "REality Software", label: "REality Software" },
  { value: "Recruit Advertising", label: "Recruit Advertising" },
  { value: "Referral", label: "Referral" },
  { value: "Relitix", label: "Relitix" },
  { value: "SmartSetter", label: "SmartSetter" },
  { value: "Sphere", label: "Sphere" },
  { value: "Text Campaign", label: "Text Campaign" },
  { value: "Walk in", label: "Walk in" },
  { value: "Wizehire", label: "Wizehire" },
  { value: "Wright Brothers", label: "Wright Brothers" },
  { value: "Ziprecruiter", label: "Ziprecruiter" },
];
